import React from "react";
import ServicesComp from "../Services/Services__Comp";

import { Col, Row } from "react-bootstrap";
import TitleHeader from "../Header/TitleHeader";
import { services } from "../../utilities";

const SectionB = ({ id, onClick }) => {
  return (
    <section>
      <div id="tab_2" className="container__services">
        <TitleHeader title={"My Services"} />
        <Row>
          {services?.map((item) => {
            return (
              <Col
                onClick={() => onClick(item)}
                md={6}
                lg={4}
                sm={12}
                className="serviceCard"
              >
                <ServicesComp
                  icon={item?.icon}
                  title={item?.title}
                  desc={item?.desc}
                />
              </Col>
            );
          })}
        </Row>
      </div>
    </section>
  );
};
export default SectionB;
